const STORAGE_KEY = 'dismissed_main_notifications_v1';

function readDismissedIds() {
  if (typeof localStorage === 'undefined') return [];
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function isNotificationDismissed(id) {
  return Boolean(id) && readDismissedIds().includes(id);
}

export function dismissNotification(id) {
  if (!id || typeof localStorage === 'undefined') return;
  const ids = new Set(readDismissedIds());
  ids.add(id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

export const notificationDismissalStorageKey = STORAGE_KEY;
